import styled, { css } from "styled-components";
import { LIGHT_GRAY, NEAR_WHITE } from "../../config";

export const Container = styled.div<{
  hasBorder?: boolean;
  readonly?: boolean;
}>`
  width: 100%;

  h5 {
    margin: 0;
    color: ${NEAR_WHITE};
    font-style: normal;
    font-weight: 700;
    margin-bottom: 10px;
  }

  div {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: ${NEAR_WHITE};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-line-clamp: 1;
    box-sizing: border-box;
    position: relative;

    ${({ hasBorder }) =>
      hasBorder &&
      css`
        padding: 9px;
        border-radius: 4px;
        border: 1px solid ${LIGHT_GRAY};
      `}

    ${({ readonly }) =>
      readonly &&
      css`
        margin-bottom: 20px;
        border: none;
        padding-left: 0px;
      `}
  }
`;
